"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = require("../store/store");
/**
 * Returns the calendar mailbox configuration object which is observable
 */
function getCalendarConfiguration() {
    return store_1.default.calendarConfiguration;
}
exports.default = getCalendarConfiguration;
//# sourceMappingURL=getCalendarConfiguration.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/owa-calendar-configuration/lib/utils/getCalendarConfiguration.js
// module id = 5254
// module chunks = 2